import { Icon } from "@evergis/ui";
import styled from "styled-components";

export const SelectContainer = styled.div`
  margin-left: 1rem;
  position: relative;
`;

export const ResultIcon = styled(Icon)`
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1.5rem;
  opacity: 0.28;
`;
